var map = {
	"./admin.svg": "121b",
	"./alert.svg": "0731",
	"./analytics.svg": "22fd",
	"./devices.svg": "fd72",
	"./home.svg": "16f9",
	"./logout.svg": "3e13",
	"./overview.svg": "fbb3",
	"./sld.svg": "94a6",
	"./support.svg": "0736"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "27e1";